import { CSElement } from './CSElement';
import { ICSElement } from '../types/interfaces';

export class ElementNavigation {
  /**
   * Обход всех элементов в глубину
   */
  public static async traverseDepthFirst(
    root: ICSElement,
    callback: (element: ICSElement) => void | Promise<void>,
    includeThis: boolean = true
  ): Promise<void> {
    const visited = new Set<string>();

    const traverse = async (element: ICSElement) => {
      if (visited.has(element.id)) return;
      visited.add(element.id);

      if (includeThis || element.id !== root.id) {
        await callback(element);
      }

      for (const child of element.getAllElements()) {
        if (child instanceof CSElement) {
          await traverse(child);
        }
      }
    };

    await traverse(root);
  }

  /**
   * Обход всех элементов в ширину
   */
  public static async traverseBreadthFirst(
    root: ICSElement,
    callback: (element: ICSElement) => void | Promise<void>,
    includeThis: boolean = true
  ): Promise<void> {
    const visited = new Set<string>();
    const queue: ICSElement[] = [root];

    while (queue.length > 0) {
      const element = queue.shift()!;

      if (visited.has(element.id)) continue;
      visited.add(element.id);

      if (includeThis || element.id !== root.id) {
        await callback(element);
      }

      element.getAllElements().forEach(child => {
        if (child instanceof CSElement && !visited.has(child.id)) {
          queue.push(child);
        }
      });
    }
  }

  /**
   * Получить путь до элемента
   */
  public static getPath(element: ICSElement): string[] {
    const path: string[] = [];
    let current: ICSElement | null = element;

    while (current) {
      path.unshift(current.name);
      current = current.mainOwner as any as ICSElement | null;
    }

    return path;
  }

  /**
   * Получить глубину элемента
   */
  public static getDepth(element: ICSElement): number {
    let depth = 0;
    let current: ICSElement | null = element.mainOwner as any as ICSElement | null;

    while (current) {
      depth++;
      current = current.mainOwner as any as ICSElement | null;
    }

    return depth;
  }

  /**
   * Найти все элементы по условию
   */
  public static async findElements(root: ICSElement, predicate: (element: ICSElement) => boolean): Promise<ICSElement[]> {
    const results: ICSElement[] = [];
    
    await this.traverseDepthFirst(root, (element) => {
      if (predicate(element)) {
        results.push(element);
      }
    });

    return results;
  }

  /**
   * Найти первый элемент по условию
   */
  public static async findElement(root: ICSElement, predicate: (element: ICSElement) => boolean): Promise<ICSElement | null> {
    let found: ICSElement | null = null;
    
    await this.traverseDepthFirst(root, (element) => {
      if (!found && predicate(element)) {
        found = element;
      }
    });

    return found;
  }
} 